// show a div. if the div is overflowing its viewable width, give it a tooltip
import React, { useRef, useState } from 'react';

import { Tooltip } from "components/Common/Tooltip/";

export const OverflowTooltipDiv = (props) => {
  const divRef = useRef(null);
  const divWithTooltipRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const checkOverflow = () => {
    // take whichever div element happens to be showing at the time
    const divElement = divRef.current || divWithTooltipRef.current;

    if (divElement) {
      // determine if the div element is overflowing by comparing scrollWidth to offsetWidth.
      // offsetWidth returns the viewable width of an element, and scrollWidth returns the full width of an element, including what is not viewable (because of overflow)
      const hasOverflow = divElement.scrollWidth > divElement.offsetWidth;
      setIsOverflowing(hasOverflow);
    }
  };

  return (
    // initially, isOverflowing will be false and the div will render without a tooltip
    // on mouse-enter, check if the current div is overflowing.
    // render the div within a tooltip element if the current div is overflowing, but if not, just render the div.
    // it will re-check on every mouse-enter and will therefore respond if the parent element has been re-sized in between mouse-overs
    <div>
      {
        isOverflowing
          ? <Tooltip {...props} >
              <div
                ref={divWithTooltipRef} 
                onMouseEnter={checkOverflow}
              >
                {props.text}
              </div>
            </Tooltip>
          : <div
              ref={divRef} 
              onMouseEnter={checkOverflow}
            >
              {props.text}
            </div>
      }
    </div>
  );
};

export default OverflowTooltipDiv;